import React from 'react';
import {Box, Button, Drawer, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import logo from '../../icons/logo.svg';
import calendar from '../../icons/calendar.svg';
import share from '../../icons/share.svg';
import {Hostage, Activity, Gender} from '../types';
import '../../style/JoinedEventDrawer.css';
import { decode } from '../../utils/Utils';

type JoinedHostageDrawerProps = {
    open: boolean;
    onClose: () => void;
    handleShare: () => void;
    hostage: Hostage | null;
    activity: Activity;
    numOfUsers: number
};


const JoinedActivityDrawer: React.FC<JoinedHostageDrawerProps> = ({open, onClose, handleShare, hostage: item, activity: event,numOfUsers}) => {
    const {t} = useTranslation();

    const formatDateForGoogle = (date: string) => {
        if (!date) {
            return;
        }
        const parsedDate = new Date(date);
        return parsedDate.toISOString().replace(/-|:|\.\d+/g, ''); // Format as YYYYMMDDTHHMMSSZ
    };

    const calculateEndTime = (startDate: string) => {
        if (!startDate) {
            return;
        }
        const parsedStartDate = new Date(startDate);
        const endDate = new Date(parsedStartDate.getTime() + 60 * 60 * 1000); // Adds 1 hour (60 minutes)
        return formatDateForGoogle(endDate.toISOString());
    };

    const googleCalendarUrl = `
        https://calendar.google.com/calendar/render?action=TEMPLATE
        &text=${encodeURIComponent(event.title)}
        &details=${encodeURIComponent(event.description)}
        &location=${encodeURIComponent(event.location)}
        &dates=${formatDateForGoogle(event.date)}/${calculateEndTime(event.date)}
      `.replace(/\s+/g, '');

    const handleAddToCalendar = () => {
        window.open(googleCalendarUrl, '_blank', 'noopener,noreferrer');
    };
    const gender: Gender = item?.gender || "male";
    const translationGenderKey = `joinedEvent.contentByGender.${gender}` as const;

    return (
        <Drawer
            className="drawer"
            anchor="bottom"
            open={open}
            onClose={onClose}
            PaperProps={{style: {borderRadius: '10px 10px 0 0'}}}
        >
            <Box className="join-activity-box">
                <Box className="close-box" onClick={onClose} />
                <Box className="logo-box" component="img" src={logo} alt="App Logo"/>
                <Typography variant="h6" className="title-text">
                    {decode(t('joinedEvent.title', {name: `${item?.first_name} ${item?.last_name}`}))}
                </Typography>
                <Typography variant="body2" className="title-text">
                    {t('joinedEvent.subtitle', {activityName: event?.title})}
                </Typography>
                <Typography variant="body2" className="content-text">
                    {t('joinedEvent.content', {numOfParticipants: numOfUsers})}
                    <br />
                    {decode(t(translationGenderKey, { name: item?.first_name}))}
                </Typography>
                <Box className="buttons-box">
                    <Button
                        className="add-to-calendar"
                        variant="contained"
                        size="medium"
                        onClick={handleAddToCalendar}>
                        <img src={calendar} alt="calendar" style={{margin: '5px'}} />
                        {t('joinedEvent.addToCalendar')}
                    </Button>
                    <Button
                        className="share"
                        variant="outlined"
                        size="medium"
                        onClick={handleShare}>
                        <img src={share} alt="share" style={{ margin: '5px' }} />
                        {t('joinedEvent.share')}
                    </Button>
                </Box>
            </Box>
        </Drawer>
    );
};

export default JoinedActivityDrawer;